const updates = [
  {
    date: '2026-08-01',
    tag: '上新',
    text: '《夏日烟火》第8集现已更新，剧情迎来重大转折',
  },
  {
    date: '2026-07-31',
    tag: '热播',
    text: '《暗夜追踪》第二季播放量突破5000万，口碑持续走高',
  },
  {
    date: '2026-07-30',
    tag: '上线',
    text: '欧美大片《星际迷航：新纪元》4K超清版正式上线',
  },
  {
    date: '2026-07-29',
    tag: '完结',
    text: '《长安十二时辰》全集已完结，一次看完全部48集',
  },
  {
    date: '2026-07-28',
    tag: '预告',
    text: '国产剧《山河令》第二季预告片发布，预计下周首播',
  },
  {
    date: '2026-07-27',
    tag: '活动',
    text: '暑期追剧季开启，每日推荐榜单助你发现好剧',
  },
  {
    date: '2026-07-26',
    tag: '上新',
    text: '日剧《深夜食堂》第五季全12集一次性上线',
  },
  {
    date: '2026-07-25',
    tag: '推荐',
    text: '本周编辑精选：五部不容错过的悬疑烧脑佳作',
  },
];

const tagColors: Record<string, string> = {
  '上新': 'bg-primary-100 text-primary-700',
  '热播': 'bg-accent-100 text-accent-800',
  '上线': 'bg-primary-100 text-primary-700',
  '完结': 'bg-secondary-100 text-secondary-800',
  '预告': 'bg-accent-100 text-accent-800',
  '活动': 'bg-secondary-100 text-secondary-800',
  '推荐': 'bg-accent-100 text-accent-800',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新动态
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              追剧不迷路，最新上线与更新一手掌握
            </p>
          </div>

          <div className="relative max-w-[720px] mx-auto">
            <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300/60" />

            <div className="space-y-6">
              {updates.map((item, i) => (
                <div key={i} className="relative flex items-start gap-4 pl-12">
                  <span className="absolute left-0 top-1 w-[38px] h-[38px] flex items-center justify-center rounded-full bg-background-50 border-2 border-background-300/60 z-10">
                    <span className="w-2.5 h-2.5 rounded-full bg-primary-500" />
                  </span>

                  <div className="flex-1 min-w-0 bg-background-50 rounded-lg border border-background-200/60 p-4">
                    <div className="flex flex-wrap items-center gap-2 mb-1">
                      <span className={`text-xs font-medium px-2 py-0.5 rounded whitespace-nowrap ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-500">{item.date}</span>
                    </div>
                    <p className="text-sm text-foreground-800 leading-relaxed">
                      {item.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}